/**
 * Calin Size Finder — modal with quiz, size chart, comparison & outfit viewer.
 * Config: assets/calin-size-finder-config.json (editable by client)
 */
(function () {
  const CUP_LABELS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H'];

  const ICONS = {
    feather: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 20c4-8 8-12 16-14-2 8-6 12-14 16z"/></svg>',
    user: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.5-7 8-7s8 3 8 7"/></svg>',
    heart: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-7-4.5-9-9a5 5 0 0 1 9-3 5 5 0 0 1 9 3c-2 4.5-9 9-9 9z"/></svg>',
    'circle-sm': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="6"/></svg>',
    'circle-md': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="8"/></svg>',
    'circle-lg': '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l5 5L20 7"/></svg>',
    cross: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    ruler: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 12h4M6 8v8M10 10v4M14 8v8M18 10v4M22 12h-4"/></svg>',
    refresh: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 12a8 8 0 0 1 14-5M20 12a8 8 0 0 1-14 5"/><path d="M16 5h4V1M4 19h4v4"/></svg>',
    mail: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 7l10 7 10-7"/></svg>',
    arrow: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    arrowBack: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>'
  };

  const OUTFIT_THUMBS = {
    'white-tee': '<rect x="8" y="0" width="32" height="42" rx="3" fill="#f0f0f0" stroke="#ccc"/><path d="M16 0 Q24 6 32 0" fill="none" stroke="#ccc"/>',
    'black-tee': '<rect x="8" y="0" width="32" height="42" rx="3" fill="#2a2a2a" stroke="#111"/>',
    fitted: '<rect x="10" y="0" width="28" height="44" rx="5" fill="#c0a8d8" stroke="#a08ac0"/>',
    'ribbed-tank': '<rect x="12" y="2" width="24" height="42" rx="3" fill="#d4c4a8" stroke="#b8a888"/><line x1="12" y1="10" x2="36" y2="10" stroke="#b8a888"/><line x1="12" y1="20" x2="36" y2="20" stroke="#b8a888"/><line x1="12" y1="30" x2="36" y2="30" stroke="#b8a888"/>',
    'silk-blouse': '<rect x="8" y="2" width="32" height="40" rx="3" fill="#e8d8f0" stroke="#c8b8d8"/>',
    hoodie: '<rect x="6" y="4" width="36" height="40" rx="5" fill="#8aacca" stroke="#6a8caa"/><path d="M16 4 Q24 2 32 4" fill="#7a9cba"/>',
    'button-shirt': '<rect x="8" y="0" width="32" height="44" rx="3" fill="#dde8f0" stroke="#b8ccd8"/><line x1="24" y1="0" x2="24" y2="44" stroke="#b8ccd8"/>',
    'crop-top': '<rect x="10" y="6" width="28" height="28" rx="4" fill="#f4a0b0" stroke="#e08898"/>'
  };

  function cmToInches(cm) {
    return cm / 2.54;
  }

  function calcBraSize(bustCm, underbustCm) {
    let band = Math.round(cmToInches(underbustCm));
    if (band % 2 !== 0) band += 1;
    band = Math.max(28, Math.min(42, band));
    let cupIdx = Math.round(cmToInches(bustCm) - cmToInches(underbustCm));
    cupIdx = Math.max(0, Math.min(cupIdx, CUP_LABELS.length - 1));
    return { band, cup: CUP_LABELS[cupIdx], size: band + CUP_LABELS[cupIdx] };
  }

  function findNobraMatch(size, table) {
    return table.find((row) => row.bras.includes(size)) || null;
  }

  function replaceTokens(str, tokens) {
    let out = str;
    Object.keys(tokens).forEach((key) => {
      out = out.split(`{${key}}`).join(tokens[key]);
    });
    return out;
  }

  function getProductUrl(config, key) {
    return (config.products && config.products[key]) || '#';
  }

  function inHalfOpenRange(value, range) {
    return value >= range[0] && value < range[1];
  }

  function getSizingEngine(config) {
    return config.sizingEngine || null;
  }

  function getEngineProducts(config) {
    const engine = getSizingEngine(config);
    return (engine && engine.products) || [];
  }

  function getEngineProductById(config, id) {
    return getEngineProducts(config).find((p) => p.id === id) || null;
  }

  function getEngineProductUrl(config, product) {
    if (!product) return '#';
    if (product.urlKey && config.products && config.products[product.urlKey]) {
      return config.products[product.urlKey];
    }
    if (product.url) return product.url;
    // Hard fallbacks matching live storefront handles
    if (product.id === 'nogap') return '/products/nogap';
    if (product.id === 'nobra') return '/products/nobra';
    if (product.id === 'nobra-plus') return '/products/nobra-1';
    return '#';
  }

  function getContactUrl(config) {
    const wa = (config.contactWhatsapp || '').replace(/[^\d+]/g, '');
    if (wa) {
      const digits = wa.replace(/\D/g, '');
      return 'https://wa.me/' + digits;
    }
    const handle = ((config.labels && config.labels.instagramHandle) || '@getcalin').replace(/^@/, '');
    return 'https://instagram.com/' + handle;
  }

  function getEngineShopUrl(config, product, size) {
    if (!product) return '#';
    let url = getEngineProductUrl(config, product);
    if (!url || url === '#') return '#';

    const variants = config.productVariants && config.productVariants[product.id];
    if (size && variants) {
      const variantId = variants[size] || variants[String(size).toUpperCase()] || variants[String(size).toLowerCase()];
      if (variantId) {
        const clean = url.split('?')[0];
        return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
      }
    }

    if (size) {
      const sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'size=' + encodeURIComponent(size);
    }
    return url;
  }

  function pathsMatch(url) {
    try {
      const target = new URL(url, window.location.origin);
      const a = window.location.pathname.replace(/\/$/, '');
      const b = target.pathname.replace(/\/$/, '');
      return a === b;
    } catch (e) {
      return false;
    }
  }

  function selectSizeOnPage(size) {
    if (!size) return false;
    const normalized = String(size).trim().toLowerCase();
    const inputs = document.querySelectorAll(
      'variant-picker input[type="radio"], variant-picker option, .variant-picker input[type="radio"]'
    );
    for (let i = 0; i < inputs.length; i += 1) {
      const el = inputs[i];
      const value = (el.value || el.textContent || '').trim().toLowerCase();
      if (value === normalized || value.indexOf(normalized) !== -1) {
        if (el.tagName === 'OPTION') {
          el.selected = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          el.click();
        }
        const picker = document.querySelector('variant-picker') || document.querySelector('[id*="variant"]');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }
    return false;
  }

  function goToRecommendedProduct(config, product, size) {
    const url = getEngineShopUrl(config, product, size);
    if (!url || url === '#') return;

    if (pathsMatch(url) && selectSizeOnPage(size)) {
      return;
    }
    window.location.href = url;
  }

  function exactFit(product, underbust, diff) {
    if (!product || !product.sizes) return null;
    for (let i = 0; i < product.sizes.length; i += 1) {
      const entry = product.sizes[i];
      if (inHalfOpenRange(underbust, entry.underbust) && inHalfOpenRange(diff, entry.diff)) {
        return entry.size;
      }
    }
    return null;
  }

  function priorityIndex(priority, id) {
    const idx = priority.indexOf(id);
    return idx === -1 ? 999 : idx;
  }

  function nearestFit(products, underbust, diff, preferProductId, overshootTolerance, fallbackPriority) {
    const candidates = [];

    products.forEach((product) => {
      (product.sizes || []).forEach((entry) => {
        if (!inHalfOpenRange(underbust, entry.underbust)) return;
        // Cup too small for this size — never recommend (adhesive / wire-free).
        if (diff < entry.diff[0]) return;
        // Exact cup range belongs to exactFit, not nearest.
        if (diff < entry.diff[1]) return;
        const overshoot = diff - entry.diff[1];
        if (overshoot <= overshootTolerance) {
          candidates.push({ product, size: entry.size, overshoot });
        }
      });
    });

    if (!candidates.length) return null;

    candidates.sort((a, b) => {
      if (a.overshoot !== b.overshoot) return a.overshoot - b.overshoot;
      const aPrefer = a.product.id === preferProductId ? 0 : 1;
      const bPrefer = b.product.id === preferProductId ? 0 : 1;
      if (aPrefer !== bPrefer) return aPrefer - bPrefer;
      return priorityIndex(fallbackPriority, a.product.id) - priorityIndex(fallbackPriority, b.product.id);
    });

    return candidates[0];
  }

  /**
   * Last-resort match. Unlike nearestFit, this never requires the underbust to land
   * inside a published range: it measures how far she sits from each size's box and
   * returns the closest one. Guarantees the engine always names a size — "no size
   * available" is not a valid answer for a stretch garment, and telling a woman she
   * doesn't fit anything is both wrong and a lost sale.
   */
  function closestAnywhere(products, underbust, diff, preferProductId, fallbackPriority) {
    const distanceTo = (value, range) => {
      if (value < range[0]) return range[0] - value;
      if (value >= range[1]) return value - range[1];
      return 0;
    };

    const candidates = [];
    products.forEach((product) => {
      (product.sizes || []).forEach((entry) => {
        const underbustGap = distanceTo(underbust, entry.underbust);
        const diffGap = distanceTo(diff, entry.diff);
        // Underbust is the reliable measurement; a bust reading is easily 5 cm light,
        // so it is weighted at a third when deciding which size she is nearest to.
        candidates.push({ product, size: entry.size, underbustGap, score: underbustGap + diffGap / 3 });
      });
    });

    if (!candidates.length) return null;

    candidates.sort((a, b) => {
      if (a.score !== b.score) return a.score - b.score;
      const aPrefer = a.product.id === preferProductId ? 0 : 1;
      const bPrefer = b.product.id === preferProductId ? 0 : 1;
      if (aPrefer !== bPrefer) return aPrefer - bPrefer;
      return priorityIndex(fallbackPriority, a.product.id) - priorityIndex(fallbackPriority, b.product.id);
    });

    return candidates[0];
  }

  /**
   * Shared sizing engine — see calin-sizing-engine-spec.md
   * Ranges are half-open: min <= x < max.
   */
  function resolveSize(bust, underbust, currentProductId, config) {
    const engine = getSizingEngine(config);
    if (!engine || !engine.products || !engine.products.length) {
      return { state: 'NONE' };
    }

    const products = engine.products;
    const fallbackPriority = engine.fallbackPriority || products.map((p) => p.id);
    const overshootTolerance = engine.overshootTolerance != null ? engine.overshootTolerance : 3;
    const diff = bust - underbust;
    const currentProduct =
      getEngineProductById(config, currentProductId) ||
      getEngineProductById(config, engine.defaultCurrentProduct) ||
      products[0];

    const currentMatch = exactFit(currentProduct, underbust, diff);
    if (currentMatch) {
      return { state: 'MATCH', product: currentProduct, size: currentMatch, diff, snug: false };
    }

    const alternatives = [];
    products.forEach((product) => {
      if (product.id === currentProduct.id) return;
      const size = exactFit(product, underbust, diff);
      if (size) alternatives.push({ product, size });
    });

    if (alternatives.length) {
      alternatives.sort(
        (a, b) => priorityIndex(fallbackPriority, a.product.id) - priorityIndex(fallbackPriority, b.product.id)
      );
      const pick = alternatives[0];
      return { state: 'CROSS', product: pick.product, size: pick.size, diff, currentProduct, snug: false };
    }

    const near = nearestFit(products, underbust, diff, currentProduct.id, overshootTolerance, fallbackPriority);
    if (near) {
      return {
        state: 'NEAREST',
        product: near.product,
        size: near.size,
        diff,
        currentProduct,
        snug: near.overshoot > 0
      };
    }

    const closest = closestAnywhere(products, underbust, diff, currentProduct.id, fallbackPriority);
    if (closest) {
      return {
        state: 'NEAREST',
        product: closest.product,
        size: closest.size,
        diff,
        currentProduct,
        snug: closest.underbustGap > 0
      };
    }

    return { state: 'NONE', diff, currentProduct };
  }

  function logSizingResult(payload) {
    console.info('[Calin sizing]', payload);
    try {
      document.dispatchEvent(new CustomEvent('calin:sizing-result', { detail: payload }));
    } catch (e) {
      /* ignore */
    }
  }

  /**
   * Homepage / bra-finder quiz validation — see calin-homepage-quiz-spec.md §7
   */
  function validateHomepageQuiz(bodyType, breastSize, bust, underbust, copy) {
    const c = copy || {};
    const diff = bust - underbust;
    const warnings = [];

    if (!(bust > 0) || !(underbust > 0)) {
      return { block: true, reason: 'missing', message: 'Please enter both measurements.', warnings };
    }
    if (bust <= underbust) {
      return {
        block: true,
        reason: 'swap',
        message: c.invalidSwap || 'Your bust is smaller than or equal to your underbust — the fields are almost certainly swapped.',
        warnings
      };
    }
    if (bust < 50 || bust > 150 || underbust < 50 || underbust > 150) {
      return {
        block: true,
        reason: 'inches',
        message: c.invalidInches || 'Those numbers look like inches. Please enter measurements in cm.',
        warnings
      };
    }
    if (diff < 8 || diff > 30) {
      return {
        block: true,
        reason: 'diff',
        message: c.invalidDiff || 'That difference looks off. Please re-measure your bust and underbust.',
        warnings
      };
    }

    if (bodyType === 'plus' && underbust < 83) {
      warnings.push({
        type: 'plus-underbust',
        message: c.warnPlusUnderbust || 'Please confirm your underbust.'
      });
    }
    if (bodyType === 'skinny' && underbust >= 83) {
      warnings.push({
        type: 'skinny-underbust',
        message: c.warnSkinnyUnderbust || 'Please confirm your underbust.'
      });
    }
    if (breastSize === 'small' && diff >= 17) {
      warnings.push({
        type: 'small-diff',
        message: c.warnSmallDiff || 'Please confirm your bust.'
      });
    }
    if (breastSize === 'large' && diff < 17) {
      warnings.push({
        type: 'large-diff',
        message: c.warnLargeDiff || 'Please confirm your bust.'
      });
    }

    return { block: false, warnings };
  }

  /**
   * Homepage bra finder — which bra + size. Uses same product charts as product-page engine.
   */
  function resolveHomepageQuiz(bodyType, breastSize, bust, underbust, config) {
    const engine = getSizingEngine(config);
    const copy = (config.quiz && config.quiz.result) || {};
    const validation = validateHomepageQuiz(bodyType, breastSize, bust, underbust, copy);

    if (validation.block) {
      return { state: 'INVALID', reason: validation.reason, message: validation.message, warnings: validation.warnings };
    }

    if (!engine || !engine.products || !engine.products.length) {
      return { state: 'NONE', warnings: validation.warnings };
    }

    // NoGap-Strapless shares NoGap's exact size ranges, so it always ties with
    // NoGap and gets co-recommended. In the size finder we recommend NoGap only.
    const products = engine.products.filter(function (p) {
      return p.id !== 'nogap-strapless';
    });
    const diff = bust - underbust;
    const overshootTolerance = engine.overshootTolerance != null ? engine.overshootTolerance : 3;
    const tiebreakMap = engine.tiebreak || {};
    const breastKey = breastSize === 'skinny' ? 'small' : breastSize;
    const tiebreakOrder =
      tiebreakMap[breastSize] ||
      tiebreakMap[breastKey] ||
      engine.fallbackPriority ||
      products.map((p) => p.id);

    const fits = [];
    products.forEach((product) => {
      const size = exactFit(product, underbust, diff);
      if (size) fits.push({ product, size });
    });

    if (fits.length === 1) {
      return {
        state: 'RESULT',
        product: fits[0].product,
        size: fits[0].size,
        tiebroken: false,
        warnings: validation.warnings,
        diff
      };
    }

    if (fits.length > 1) {
      fits.sort(
        (a, b) => priorityIndex(tiebreakOrder, a.product.id) - priorityIndex(tiebreakOrder, b.product.id)
      );
      const pick = fits[0];
      const alt = fits.find((f) => f.product.id !== pick.product.id);
      return {
        state: 'RESULT',
        product: pick.product,
        size: pick.size,
        tiebroken: true,
        alternatives: fits,
        altProduct: alt ? alt.product : null,
        warnings: validation.warnings,
        diff
      };
    }

    const near = nearestFit(products, underbust, diff, null, overshootTolerance, tiebreakOrder);
    if (near) {
      return {
        state: 'RESULT_SNUG',
        product: near.product,
        size: near.size,
        snug: near.overshoot > 0,
        warnings: validation.warnings,
        diff
      };
    }

    return { state: 'NONE', warnings: validation.warnings, diff };
  }

  function deepMerge(target, source) {
    const out = { ...target };
    Object.keys(source).forEach((key) => {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        out[key] = deepMerge(target[key] || {}, source[key]);
      } else if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
        out[key] = source[key];
      }
    });
    return out;
  }

  async function loadConfig(el) {
    let base = null;
    const url = el.dataset.configUrl;
    if (url) {
      try {
        const res = await fetch(url);
        base = await res.json();
      } catch (e) {
        console.warn('Calin Size Finder: could not load config', e);
      }
    }

    const inline = el.querySelector('[data-calin-sf-config]');
    if (inline) {
      try {
        const overrides = JSON.parse(inline.textContent);
        base = base ? deepMerge(base, overrides) : overrides;
      } catch (e) {
        console.warn('Calin Size Finder: invalid inline config');
      }
    }

    return base;
  }

  class CalinSizeFinderApp {
    constructor(root, config, options = {}) {
      this.root = root;
      this.config = config;
      this.options = options;
      this.state = { body: null, breast: null, quizStep: 1, outfitIdx: 0, quizWarningConfirmed: false };
      this.render();
      this.bind();
    }

    render() {
      const only = this.options.only;
      // Size finder panel only renders in the standalone inline finder section (only === 'finder').
      // It is commented out of the tabbed size-chart drawer below (kept for future use).
      const showFinder = only === 'finder';
      const showChart = !only || only === 'chart';
      // Tabs (.calin-sf__tabs) commented out — size finder no longer uses tabs.
      // const showTabs = !only;
      // ${showTabs ? `<nav class="calin-sf__tabs" role="tablist">
      //   <button type="button" class="calin-sf__tab" data-tab="finder" role="tab">${c.labels.tabFinder}</button>
      //   <button type="button" class="calin-sf__tab is-active" data-tab="chart" role="tab">${c.labels.tabChart}</button>
      //   ${c.comparison ? `<button type="button" class="calin-sf__tab" data-tab="comparison" role="tab">${c.labels.tabComparison}</button>` : ''}
      //   ${c.outfits ? `<button type="button" class="calin-sf__tab" data-tab="outfits" role="tab">${c.labels.tabOutfits}</button>` : ''}
      // </nav>` : ''}
      const c = this.config;
      this.root.innerHTML = `
        <div class="calin-sf" data-calin-sf-app>
          ${showFinder ? `<div class="calin-sf__panel is-active" data-panel="finder">${this.renderQuizPanel()}</div>` : ''}
          ${showChart ? `<div class="calin-sf__panel${showFinder ? '' : ' is-active'}" data-panel="chart">${this.renderChartPanel()}</div>` : ''}
          ${'' /* Why Calin panel commented out
          ${c.comparison ? `<div class="calin-sf__panel" data-panel="comparison">${this.renderComparisonPanel()}</div>` : ''}
          */}
          ${'' /* Under outfits panel commented out (moved to standalone "Calin outfits" section)
          ${c.outfits ? `<div class="calin-sf__panel" data-panel="outfits">${this.renderOutfitsPanel()}</div>` : ''}
          */}
        </div>`;
    }

    renderQuizPanel() {
      const q = this.config.quiz;
      const s1 = q.step1;
      const s2 = q.step2;
      const s3 = q.step3;
      return `
        <div class="calin-sf__progress"><div class="calin-sf__progress-fill" data-quiz-progress style="width:0%"></div></div>
        <div class="calin-sf__step is-active" data-quiz-step="1">
          <p class="calin-sf__step-label">${s1.label}</p>
          <p class="calin-sf__step-q">${s1.question}</p>
          <p class="calin-sf__step-sub">${s1.sub}</p>
          <div class="calin-sf__option-grid">${s1.options.map((o) => `
            <button type="button" class="calin-sf__option" data-quiz-select="body" data-value="${o.id}">
              <div class="calin-sf__option-icon">${ICONS[o.icon] || ''}</div>
              <p class="calin-sf__option-label">${o.label}</p>
              <p class="calin-sf__option-desc">${o.desc}</p>
            </button>`).join('')}</div>
          <button type="button" class="calin-sf__btn calin-sf__btn--outline" data-quiz-next="2" disabled>Next ${ICONS.arrow}</button>
        </div>
        <div class="calin-sf__step" data-quiz-step="2">
          <p class="calin-sf__step-label">${s2.label}</p>
          <p class="calin-sf__step-q">${s2.question}</p>
          <p class="calin-sf__step-sub">${s2.sub}</p>
          <div class="calin-sf__option-grid">${s2.options.map((o) => `
            <button type="button" class="calin-sf__option" data-quiz-select="breast" data-value="${o.id}">
              <div class="calin-sf__option-icon">${ICONS[o.icon] || ''}</div>
              <p class="calin-sf__option-label">${o.label}</p>
              <p class="calin-sf__option-desc">${o.desc}</p>
            </button>`).join('')}</div>
          <button type="button" class="calin-sf__btn calin-sf__btn--outline" data-quiz-next="3" disabled>Next ${ICONS.arrow}</button>
          <button type="button" class="calin-sf__btn calin-sf__btn--ghost" data-quiz-back="1">${ICONS.arrowBack} Back</button>
        </div>
        <div class="calin-sf__step" data-quiz-step="3">
          <p class="calin-sf__step-label">${s3.label}</p>
          <p class="calin-sf__step-q">${s3.question}</p>
          <p class="calin-sf__step-sub">${s3.sub}</p>
          <div class="calin-sf__meas-row">
            <div class="calin-sf__meas-card">
              <p class="calin-sf__meas-label">Underbust</p>
              <p class="calin-sf__meas-hint">Directly under your breasts where a bra band sits</p>
              <div class="calin-sf__input-row">
                <input class="calin-sf__input" type="number" data-quiz-und placeholder="72" min="50" max="150">
                <span class="calin-sf__unit">cm</span>
              </div>
            </div>
            <div class="calin-sf__meas-card">
              <p class="calin-sf__meas-label">Bust</p>
              <p class="calin-sf__meas-hint">Around the fullest part of your chest, tape parallel to the floor</p>
              <div class="calin-sf__input-row">
                <input class="calin-sf__input" type="number" data-quiz-bust placeholder="88" min="50" max="150">
                <span class="calin-sf__unit">cm</span>
              </div>
            </div>
          </div>
          <div class="calin-sf__quiz-alert" data-quiz-alert hidden></div>
          <button type="button" class="calin-sf__btn calin-sf__btn--outline" data-quiz-result>Show my result ${ICONS.arrow}</button>
          <button type="button" class="calin-sf__btn calin-sf__btn--ghost" data-quiz-back="2">${ICONS.arrowBack} Back</button>
        </div>
        <div class="calin-sf__step" data-quiz-step="result">
          <div class="calin-sf__rec-card" data-quiz-rec-card>
            <span class="calin-sf__tag" data-quiz-rec-tag>${q.result.recTag}</span>
            <div class="calin-sf__rec-name" data-quiz-rec-name></div>
            <div class="calin-sf__rec-tagline" data-quiz-rec-tagline></div>
            <div class="calin-sf__rec-desc" data-quiz-rec-desc></div>
          </div>
          <div class="calin-sf__result-actions" data-quiz-result-actions></div>
          <button type="button" class="calin-sf__btn calin-sf__btn--ghost" data-quiz-restart>${ICONS.refresh} Start over</button>
        </div>`;
    }

    renderChartPanel() {
      const sf = this.config.sizeFinder;
      const productId = this.getCurrentProductId();
      const refs = (this.config.sizeReferences && this.config.sizeReferences[productId])
        || (this.config.sizeReferences && this.config.sizeReferences.nobra)
        || null;
      const tableHeading = (refs && refs.heading) || sf.tableHeading || 'Size reference';
      const tableRows = (refs && refs.rows) || [];
      const tableColumns = (refs && refs.columns) || null;
      const tableNote = refs && refs.note ? `<p class="calin-sf__table-note">${refs.note}</p>` : '';
      return `
        <p class="calin-sf__label">${sf.label}</p>
        <h3 class="calin-sf__heading">${sf.heading}</h3>
        <p class="calin-sf__sub">${sf.sub}</p>
        <div class="calin-sf__meas-row">
          <div class="calin-sf__meas-card">
            <p class="calin-sf__meas-label">Step 1</p>
            <p class="calin-sf__meas-label">${sf.underbustLabel}</p>
            <p class="calin-sf__meas-hint">${sf.underbustHint}</p>
            <div class="calin-sf__input-row">
              <input class="calin-sf__input" type="number" data-chart-und placeholder="72" min="${this.config.limits.underbustMin}" max="${this.config.limits.underbustMax}">
              <span class="calin-sf__unit">cm</span>
            </div>
            <p class="calin-sf__err" data-chart-und-err>Please enter a value between ${this.config.limits.underbustMin}–${this.config.limits.underbustMax} cm</p>
          </div>
          <div class="calin-sf__meas-card">
            <p class="calin-sf__meas-label">Step 2</p>
            <p class="calin-sf__meas-label">${sf.bustLabel}</p>
            <p class="calin-sf__meas-hint">${sf.bustHint}</p>
            <div class="calin-sf__input-row">
              <input class="calin-sf__input" type="number" data-chart-bust placeholder="88" min="${this.config.limits.bustMin}" max="${this.config.limits.bustMax}">
              <span class="calin-sf__unit">cm</span>
            </div>
            <p class="calin-sf__err" data-chart-bust-err>Please enter a value between ${this.config.limits.bustMin}–${this.config.limits.bustMax} cm</p>
          </div>
        </div>
        <button type="button" class="calin-sf__btn calin-sf__btn--outline" data-chart-find>${sf.findBtn} ${ICONS.arrow}</button>
        <div class="calin-sf__result-card" data-chart-engine-result>
          <span class="calin-sf__tag" data-chart-result-tag></span>
          <div class="calin-sf__result-headline" data-chart-result-headline></div>
          <div class="calin-sf__result-size" data-chart-result-size></div>
          <div class="calin-sf__result-calin" data-chart-result-calin></div>
          <div class="calin-sf__result-note" data-chart-result-note></div>
          <div class="calin-sf__result-actions" data-chart-result-actions></div>
        </div>
        ${'' /* Legacy plus/coming-soon result card replaced by sizing engine states (MATCH/CROSS/NEAREST/NONE)
        <div class="calin-sf__result-card" data-chart-result>...</div>
        <div class="calin-sf__result-card" data-chart-plus>...</div>
        */}
        ${this.options.hideReference ? '' : `
        <div class="calin-sf__table-wrap">
          <p class="calin-sf__table-head">${tableHeading}</p>
          <table class="calin-sf__table" data-chart-table>
            <thead><tr>${(tableColumns || ['SIZE', 'US/EU']).map((c) => `<th>${c}</th>`).join('')}</tr></thead>
            <tbody>${tableRows.map((r) => `<tr data-size="${r.size}"><td>${r.size}</td>${r.fits ? `<td>${r.fits}</td>` : ''}<td>${r.usEu}</td></tr>`).join('')}</tbody>
          </table>
          ${tableNote}
        </div>
        <div class="calin-sf__tip-grid">${this.config.tips.map((t) => `
          <div class="calin-sf__tip-card">
            <div class="calin-sf__tip-icon">${ICONS[t.icon] || ICONS.heart}</div>
            <p class="calin-sf__tip-text">${t.text}</p>
          </div>`).join('')}</div>`}
        ${'' /* Size reference table + tip text — kept for size chart popup/drawer.
            Hidden on inline section when options.hideReference is true (do not delete):
        <div class="calin-sf__table-wrap">...</div>
        <div class="calin-sf__tip-grid">...</div>
        */}`;
    }

    renderComparisonPanel() {
      const comp = this.config.comparison;
      return `
        <p class="calin-sf__label">${comp.label}</p>
        <h3 class="calin-sf__heading">${comp.heading}</h3>
        <p class="calin-sf__sub">${comp.sub}</p>
        <div class="calin-sf__comp-headers">
          <div class="calin-sf__comp-header"><p class="calin-sf__comp-header-label">${comp.oldLabel}</p><p class="calin-sf__comp-header-name">${comp.oldName}</p></div>
          <div class="calin-sf__comp-header calin-sf__comp-header--spacer"></div>
          <div class="calin-sf__comp-header calin-sf__comp-header--calin"><p class="calin-sf__comp-header-label">${comp.calinLabel}</p><p class="calin-sf__comp-header-name">${comp.calinName}</p></div>
        </div>
        <div class="calin-sf__comp-table">${comp.rows.map((row) => `
          <div class="calin-sf__comp-row">
            <div class="calin-sf__comp-cell"><span class="calin-sf__icon-cross">${ICONS.cross}</span><p class="calin-sf__comp-text--bad">${row.bad}</p></div>
            <div class="calin-sf__comp-cell calin-sf__comp-cell--feature"><p class="calin-sf__comp-feature">${row.feature}</p><p class="calin-sf__comp-feature-sub">${row.sub}</p></div>
            <div class="calin-sf__comp-cell calin-sf__comp-cell--calin"><span class="calin-sf__icon-check">${ICONS.check}</span><p class="calin-sf__comp-text--good">${row.good}</p></div>
          </div>`).join('')}</div>
        <div class="calin-sf__testi-row">${comp.testimonials.map((t) => `
          <div class="calin-sf__testi-card"><p class="calin-sf__testi-quote">"${t.quote}"</p><p class="calin-sf__testi-name">${t.name}</p></div>`).join('')}</div>
        <div class="calin-sf__cta-row">
          <button type="button" class="calin-sf__btn calin-sf__btn--primary" data-comp-cta="nobra">${comp.ctaPrimary} ${ICONS.arrow}</button>
          <button type="button" class="calin-sf__btn calin-sf__btn--outline" data-comp-cta="allBras">${comp.ctaSecondary}</button>
        </div>`;
    }

    renderOutfitsPanel() {
      const o = this.config.outfits;
      return `
        <p class="calin-sf__label">${o.label}</p>
        <h3 class="calin-sf__heading">${o.heading}</h3>
        <p class="calin-sf__sub">${o.sub}</p>
        <div class="calin-sf__shirt-grid" data-outfit-grid></div>
        <div class="calin-sf__viewer">
          <div class="calin-sf__viewer-visual"><svg viewBox="0 0 48 44" data-outfit-svg></svg></div>
          <div class="calin-sf__viewer-info">
            <span class="calin-sf__tag" data-outfit-tag></span>
            <p class="calin-sf__viewer-title" data-outfit-title></p>
            <p class="calin-sf__viewer-verdict" data-outfit-verdict></p>
            <p class="calin-sf__viewer-desc" data-outfit-desc></p>
            <div class="calin-sf__verdict-list" data-outfit-points></div>
          </div>
        </div>`;
    }

    bind() {
      this.root.querySelectorAll('[data-tab]').forEach((tab) => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
      });
      this.bindQuiz();
      this.bindChart();
      // this.bindComparison(); // Why Calin commented out
      // this.renderOutfits(); // Under outfits commented out (moved to standalone "Calin outfits" section)
    }

    switchTab(id) {
      this.root.querySelectorAll('[data-tab]').forEach((t) => t.classList.toggle('is-active', t.dataset.tab === id));
      this.root.querySelectorAll('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === id));
    }

    setQuizStep(step) {
      this.state.quizStep = step;
      const pct = step === 1 ? 0 : step === 2 ? 33 : step === 3 ? 66 : 100;
      const progress = this.root.querySelector('[data-quiz-progress]');
      if (progress) progress.style.width = pct + '%';
      this.root.querySelectorAll('[data-quiz-step]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.quizStep === String(step));
      });
    }

    bindQuiz() {
      this.root.querySelectorAll('[data-quiz-select]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.quizSelect;
          this.state[key] = btn.dataset.value;
          btn.closest('.calin-sf__option-grid').querySelectorAll('.calin-sf__option').forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          const nextBtn = this.root.querySelector(`[data-quiz-next="${key === 'body' ? '2' : '3'}"]`);
          if (nextBtn) nextBtn.disabled = false;
        });
      });
      this.root.querySelectorAll('[data-quiz-next]').forEach((btn) => {
        btn.addEventListener('click', () => this.setQuizStep(Number(btn.dataset.quizNext)));
      });
      this.root.querySelectorAll('[data-quiz-back]').forEach((btn) => {
        btn.addEventListener('click', () => this.setQuizStep(Number(btn.dataset.quizBack)));
      });
      this.root.querySelector('[data-quiz-result]')?.addEventListener('click', () => this.showQuizResult());
      this.root.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.restartQuiz());
      this.root.querySelector('[data-quiz-bust]')?.addEventListener('input', () => {
        this.state.quizWarningConfirmed = false;
        this.clearQuizAlert();
      });
      this.root.querySelector('[data-quiz-und]')?.addEventListener('input', () => {
        this.state.quizWarningConfirmed = false;
        this.clearQuizAlert();
      });
    }

    clearQuizAlert() {
      const alert = this.root.querySelector('[data-quiz-alert]');
      if (!alert) return;
      alert.hidden = true;
      alert.innerHTML = '';
      alert.className = 'calin-sf__quiz-alert';
    }

    showQuizAlert(message, options = {}) {
      const alert = this.root.querySelector('[data-quiz-alert]');
      const copy = (this.config.quiz && this.config.quiz.result) || {};
      if (!alert) return;
      alert.hidden = false;
      alert.className = 'calin-sf__quiz-alert' + (options.block ? ' is-block' : ' is-warn');
      let actions = '';
      if (options.swap) {
        actions += `<button type="button" class="calin-sf__btn calin-sf__btn--outline" data-quiz-swap>${copy.swapCta || 'Swap bust & underbust'}</button>`;
      }
      if (options.confirm) {
        actions += `<button type="button" class="calin-sf__btn calin-sf__btn--primary" data-quiz-confirm-warn>${copy.confirmCta || 'Yes, measurements are correct'}</button>`;
        actions += `<button type="button" class="calin-sf__btn calin-sf__btn--ghost" data-quiz-edit-meas>${copy.editCta || 'Edit measurements'}</button>`;
      }
      alert.innerHTML = `<p class="calin-sf__quiz-alert-text">${message}</p><div class="calin-sf__quiz-alert-actions">${actions}</div>`;

      alert.querySelector('[data-quiz-swap]')?.addEventListener('click', () => {
        const bustEl = this.root.querySelector('[data-quiz-bust]');
        const undEl = this.root.querySelector('[data-quiz-und]');
        if (!bustEl || !undEl) return;
        const tmp = bustEl.value;
        bustEl.value = undEl.value;
        undEl.value = tmp;
        this.state.quizWarningConfirmed = false;
        this.clearQuizAlert();
        this.showQuizResult();
      });
      alert.querySelector('[data-quiz-confirm-warn]')?.addEventListener('click', () => {
        this.state.quizWarningConfirmed = true;
        this.clearQuizAlert();
        this.showQuizResult();
      });
      alert.querySelector('[data-quiz-edit-meas]')?.addEventListener('click', () => {
        this.clearQuizAlert();
        this.root.querySelector('[data-quiz-bust]')?.focus();
      });
    }

    showQuizResult() {
      const bust = parseFloat(this.root.querySelector('[data-quiz-bust]')?.value);
      const und = parseFloat(this.root.querySelector('[data-quiz-und]')?.value);
      const bodyType = this.state.body;
      const breastSize = this.state.breast;
      if (!bodyType || !breastSize) return;

      this.clearQuizAlert();

      const result = resolveHomepageQuiz(bodyType, breastSize, bust, und, this.config);

      if (result.state === 'INVALID') {
        this.showQuizAlert(result.message, {
          block: true,
          swap: result.reason === 'swap'
        });
        return;
      }

      if (result.warnings && result.warnings.length && !this.state.quizWarningConfirmed) {
        const message = result.warnings.map((w) => w.message).join(' ');
        logSizingResult({
          state: 'SOFT_WARNING',
          bust,
          underbust: und,
          bodyType,
          breastSize,
          warnings: result.warnings,
          timestamp: new Date().toISOString()
        });
        this.showQuizAlert(message, { confirm: true });
        return;
      }

      this.renderHomepageQuizResult(result, bust, und, bodyType, breastSize);
      this.setQuizStep('result');
    }

    renderHomepageQuizResult(result, bust, underbust, bodyType, breastSize) {
      const copy = (this.config.quiz && this.config.quiz.result) || {};
      const tagEl = this.root.querySelector('[data-quiz-rec-tag]');
      const nameEl = this.root.querySelector('[data-quiz-rec-name]');
      const taglineEl = this.root.querySelector('[data-quiz-rec-tagline]');
      const descEl = this.root.querySelector('[data-quiz-rec-desc]');
      const actionsEl = this.root.querySelector('[data-quiz-result-actions]');
      const contactUrl = getContactUrl(this.config);
      const product = result.product;
      const breastLabel =
        breastSize === 'small' ? 'small' : breastSize === 'large' ? 'large' : 'medium';

      const tokens = {
        product: product ? product.name : '',
        size: result.size || '',
        breast: breastLabel,
        alt: result.altProduct ? result.altProduct.name : ''
      };

      this._shopUrl = product ? getEngineShopUrl(this.config, product, result.size) : '';

      if (tagEl) tagEl.textContent = copy.recTag || 'Your bra';
      if (actionsEl) actionsEl.innerHTML = '';

      if (result.state === 'RESULT') {
        if (nameEl) {
          nameEl.textContent = replaceTokens(
            copy.headline || 'Your bra is the {product}, in size {size}.',
            tokens
          );
        }
        if (taglineEl) {
          taglineEl.textContent = product ? product.name + ' · Size ' + result.size : '';
        }
        if (descEl) {
          descEl.textContent =
            result.tiebroken && result.altProduct
              ? replaceTokens(
                  copy.tiebreakNote ||
                    'Both our {alt} and {product} fit your measurements. Since you described yourself as {breast}, the {product} is the better match.',
                  tokens
                )
              : '';
        }
        if (actionsEl) {
          actionsEl.innerHTML = `<a class="calin-sf__btn calin-sf__btn--primary" href="${this._shopUrl}" data-calin-shop-cta>${replaceTokens(copy.shopCta || 'Shop {product} {size}', tokens)} ${ICONS.arrow}</a>`;
        }
      } else if (result.state === 'RESULT_SNUG') {
        if (nameEl) nameEl.textContent = copy.snugHeadline || 'Your measurements sit just outside our size range.';
        if (taglineEl) {
          taglineEl.textContent = product ? product.name + ' · Size ' + result.size : '';
        }
        if (descEl) {
          descEl.textContent = replaceTokens(
            copy.snugNote || 'Closest fit: {product} {size}. It may feel a little snug.',
            tokens
          );
        }
        if (actionsEl) {
          actionsEl.innerHTML = `
            <a class="calin-sf__btn calin-sf__btn--primary" href="${this._shopUrl}" data-calin-shop-cta>${replaceTokens(copy.snugCta || 'Shop {product} {size}', tokens)} ${ICONS.arrow}</a>
            <a class="calin-sf__btn calin-sf__btn--outline" href="${contactUrl}" target="_blank" rel="noopener">${copy.snugContactCta || 'Talk to us'}</a>`;
        }
        logSizingResult({
          state: 'RESULT_SNUG',
          bust,
          underbust,
          bodyType,
          breastSize,
          productId: product && product.id,
          size: result.size,
          timestamp: new Date().toISOString()
        });
      } else {
        if (nameEl) nameEl.textContent = copy.noneHeadline || "Please contact our Bra Expert to find the right size for you.";
        if (taglineEl) taglineEl.textContent = '';
        if (descEl) descEl.textContent = '';
        if (actionsEl) {
          actionsEl.innerHTML = `<a class="calin-sf__btn calin-sf__btn--outline" href="${contactUrl}" target="_blank" rel="noopener">${copy.noneContactCta || 'Contact us'}</a>`;
        }
        logSizingResult({
          state: 'NONE',
          bust,
          underbust,
          bodyType,
          breastSize,
          timestamp: new Date().toISOString()
        });
      }

      this.bindShopCtas(product, result.size);
    }

    bindShopCtas(product, size) {
      this.root.querySelectorAll('[data-calin-shop-cta]').forEach((link) => {
        link.addEventListener('click', (e) => {
          if (!product) return;
          const url = getEngineShopUrl(this.config, product, size);
          if (pathsMatch(url) && selectSizeOnPage(size)) {
            e.preventDefault();
            return;
          }
          // Let the browser follow href (includes ?variant= when available).
        });
      });
    }

    restartQuiz() {
      this.state = { body: null, breast: null, quizStep: 1, outfitIdx: 0, quizWarningConfirmed: false };
      this._shopUrl = '';
      this.root.querySelectorAll('[data-quiz-select]').forEach((b) => b.classList.remove('is-selected'));
      const next2 = this.root.querySelector('[data-quiz-next="2"]');
      const next3 = this.root.querySelector('[data-quiz-next="3"]');
      if (next2) next2.disabled = true;
      if (next3) next3.disabled = true;
      const bustEl = this.root.querySelector('[data-quiz-bust]');
      const undEl = this.root.querySelector('[data-quiz-und]');
      if (bustEl) bustEl.value = '';
      if (undEl) undEl.value = '';
      this.clearQuizAlert();
      this.setQuizStep(1);
    }

    bindChart() {
      this.root.querySelector('[data-chart-find]')?.addEventListener('click', () => this.findChartSize());
      this.root.querySelector('[data-chart-bust]')?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') this.findChartSize();
      });
      this.root.querySelector('[data-chart-und]')?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') this.findChartSize();
      });
    }

    getCurrentProductId() {
      const engine = getSizingEngine(this.config);
      return (
        this.options.currentProduct ||
        (engine && engine.defaultCurrentProduct) ||
        'nobra'
      );
    }

    findChartSize() {
      const bustEl = this.root.querySelector('[data-chart-bust]');
      const undEl = this.root.querySelector('[data-chart-und]');
      if (!bustEl || !undEl) return;

      const bust = parseFloat(bustEl.value);
      const und = parseFloat(undEl.value);
      const lim = this.config.limits;
      const sf = this.config.sizeFinder;
      const resultCard = this.root.querySelector('[data-chart-engine-result]');

      this.root.querySelector('[data-chart-bust-err]')?.classList.remove('is-visible');
      this.root.querySelector('[data-chart-und-err]')?.classList.remove('is-visible');
      resultCard?.classList.remove('is-visible');
      this.root.querySelectorAll('[data-chart-table] tr').forEach((r) => r.classList.remove('is-highlight'));

      let valid = true;
      if (!bust || bust < lim.bustMin || bust > lim.bustMax) {
        this.root.querySelector('[data-chart-bust-err]')?.classList.add('is-visible');
        valid = false;
      }
      if (!und || und < lim.underbustMin || und > lim.underbustMax) {
        this.root.querySelector('[data-chart-und-err]')?.classList.add('is-visible');
        valid = false;
      }
      if (!valid || !resultCard) return;

      const currentProductId = this.getCurrentProductId();
      const result = resolveSize(bust, und, currentProductId, this.config);
      this.renderEngineResult(result, bust, und, currentProductId);

      if (result.state === 'MATCH' && result.size) {
        const row = this.root.querySelector(`[data-chart-table] tr[data-size="${result.size}"]`);
        if (row) row.classList.add('is-highlight');
      }
    }

    renderEngineResult(result, bust, underbust, currentProductId) {
      const sf = this.config.sizeFinder;
      const resultCard = this.root.querySelector('[data-chart-engine-result]');
      if (!resultCard) return;

      const tagEl = resultCard.querySelector('[data-chart-result-tag]');
      const headlineEl = resultCard.querySelector('[data-chart-result-headline]');
      const sizeEl = resultCard.querySelector('[data-chart-result-size]');
      const calinEl = resultCard.querySelector('[data-chart-result-calin]');
      const noteEl = resultCard.querySelector('[data-chart-result-note]');
      const actionsEl = resultCard.querySelector('[data-chart-result-actions]');

      const currentProduct =
        result.currentProduct || getEngineProductById(this.config, currentProductId);
      const product = result.product;
      const contactUrl = getContactUrl(this.config);
      const tokens = {
        size: result.size || '',
        product: product ? product.name : '',
        current: currentProduct ? currentProduct.name : '',
        calinSize: result.size || ''
      };

      tagEl.textContent = '';
      headlineEl.textContent = '';
      sizeEl.textContent = '';
      calinEl.textContent = '';
      noteEl.textContent = '';
      actionsEl.innerHTML = '';
      resultCard.dataset.state = result.state;

      if (result.state === 'MATCH') {
        tagEl.textContent = sf.matchTag || 'Your size';
        headlineEl.textContent = replaceTokens(sf.matchHeadline || 'Your size: {size}', tokens);
        sizeEl.textContent = result.size;
        calinEl.textContent = product ? product.name + ' size: ' + result.size : result.size;
        noteEl.textContent = replaceTokens(sf.matchNote || '', {
          ...tokens,
          size: result.size,
          product: product ? product.name : ''
        });
        // Same-product match: text only (no button) — shop CTA just reloads the PDP.
        const matchLabel = replaceTokens(sf.matchCta || sf.crossCta || 'Shop {product} {size}', tokens);
        actionsEl.innerHTML = `<p class="calin-sf__shop-label">${matchLabel}</p>`;
      } else if (result.state === 'CROSS') {
        tagEl.textContent = sf.crossTag || 'Better match';
        headlineEl.textContent = replaceTokens(
          sf.crossHeadline || '{current} doesn\'t come in your size — but {product} does.',
          tokens
        );
        sizeEl.textContent = result.size;
        calinEl.textContent = product ? product.name + ' size: ' + result.size : result.size;
        noteEl.textContent = replaceTokens(sf.crossNote || 'Your size in {product} is {size}.', tokens);
        const shopUrl = getEngineShopUrl(this.config, product, result.size);
        actionsEl.innerHTML = `<a class="calin-sf__btn calin-sf__btn--primary" href="${shopUrl}" data-calin-shop-cta>${replaceTokens(sf.crossCta || 'Shop {product} {size}', tokens)} ${ICONS.arrow}</a>`;
      } else if (result.state === 'NEAREST') {
        tagEl.textContent = sf.nearestTag || 'Closest fit';
        headlineEl.textContent = sf.nearestHeadline || 'Your measurements sit just outside our size range.';
        sizeEl.textContent = result.size;
        calinEl.textContent = product ? product.name + ' size: ' + result.size : result.size;
        noteEl.textContent = replaceTokens(
          sf.nearestNote || 'Closest fit: {product} {size}. It may feel a little snug.',
          tokens
        );
        const shopUrl = getEngineShopUrl(this.config, product, result.size);
        const nearestLabel = replaceTokens(sf.nearestCta || 'Shop {product} {size}', tokens);
        // Same page → text only; other product → keep shop button.
        const shopAction = pathsMatch(shopUrl)
          ? `<p class="calin-sf__shop-label">${nearestLabel}</p>`
          : `<a class="calin-sf__btn calin-sf__btn--primary" href="${shopUrl}" data-calin-shop-cta>${nearestLabel} ${ICONS.arrow}</a>`;
        actionsEl.innerHTML = `
          ${shopAction}
          <a class="calin-sf__btn calin-sf__btn--outline" href="${contactUrl}" target="_blank" rel="noopener">${sf.nearestContactCta || 'Talk to us'}</a>`;
        logSizingResult({
          state: 'NEAREST',
          bust,
          underbust,
          currentProductId,
          productId: product && product.id,
          size: result.size,
          timestamp: new Date().toISOString()
        });
      } else {
        tagEl.textContent = sf.noneTag || 'No match';
        headlineEl.textContent = sf.noneHeadline || 'We don\'t have a match for your measurements yet.';
        sizeEl.textContent = '';
        calinEl.textContent = '';
        noteEl.textContent = '';
        actionsEl.innerHTML = `<a class="calin-sf__btn calin-sf__btn--outline" href="${contactUrl}" target="_blank" rel="noopener">${sf.noneContactCta || 'Contact us'}</a>`;
        logSizingResult({
          state: 'NONE',
          bust,
          underbust,
          currentProductId,
          timestamp: new Date().toISOString()
        });
      }

      resultCard.classList.add('is-visible');
      this.bindShopCtas(product, result.size);
    }

    bindComparison() {
      this.root.querySelectorAll('[data-comp-cta]').forEach((btn) => {
        btn.addEventListener('click', () => {
          window.location.href = getProductUrl(this.config, btn.dataset.compCta);
        });
      });
    }

    renderOutfits() {
      const grid = this.root.querySelector('[data-outfit-grid]');
      if (!grid || !this.config.outfits) return;
      const items = this.config.outfits.items;
      grid.innerHTML = items.map((item, i) => `
        <button type="button" class="calin-sf__shirt-btn${i === this.state.outfitIdx ? ' is-active' : ''}" data-outfit-idx="${i}">
          <svg class="calin-sf__shirt-thumb" viewBox="0 0 48 44">${OUTFIT_THUMBS[item.id] || ''}</svg>
          <span class="calin-sf__shirt-name">${item.name}</span>
        </button>`).join('');
      grid.querySelectorAll('[data-outfit-idx]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.state.outfitIdx = Number(btn.dataset.outfitIdx);
          this.renderOutfits();
        });
      });
      const item = items[this.state.outfitIdx];
      const svg = this.root.querySelector('[data-outfit-svg]');
      if (svg) svg.innerHTML = OUTFIT_THUMBS[item.id] || '';
      this.root.querySelector('[data-outfit-tag]').textContent = item.tag;
      this.root.querySelector('[data-outfit-title]').textContent = item.name;
      this.root.querySelector('[data-outfit-verdict]').textContent = item.verdict;
      this.root.querySelector('[data-outfit-desc]').textContent = item.desc;
      this.root.querySelector('[data-outfit-points]').innerHTML = item.points.map((p) => `
        <div class="calin-sf__verdict-item">${ICONS.check}<span>${p}</span></div>`).join('');
    }
  }

  let focusElement = '';

  function trapFocus(container) {
    const focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    container._calinSfFocusHandler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', container._calinSfFocusHandler);
    first.focus();
  }

  function removeTrapFocus(container) {
    if (container && container._calinSfFocusHandler) {
      container.removeEventListener('keydown', container._calinSfFocusHandler);
      delete container._calinSfFocusHandler;
    }
  }

  function bindDrawerClose(drawer, onClose) {
    drawer.querySelectorAll('[data-close-drawer]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        onClose(drawer);
      });
    });
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('open');
    if (focusElement) focusElement.focus();
    focusElement = '';
    removeTrapFocus(drawer);
    setTimeout(() => drawer.remove(), 400);
  }

  class CalinSizeFinder extends HTMLElement {
    constructor() {
      super();
      this._config = null;
      this._app = null;
      const trigger = this.querySelector('[data-calin-sf-open]');
      if (trigger) {
        trigger.addEventListener('click', (e) => this.openDrawer(e));
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const drawer = document.querySelector('.calin-sf-drawer.open');
          if (drawer) this._closeDrawer(drawer);
        }
      });
    }

    async getConfig() {
      if (this._config) return this._config;
      this._config = await loadConfig(this);
      return this._config;
    }

    async openDrawer(event) {
      event.preventDefault();
      const config = await this.getConfig();
      if (!config) return;

      const template = this.querySelector('[data-calin-sf-template]');
      if (!template) return;
      const content = template.content.cloneNode(true);
      document.body.appendChild(content);

      const drawer = document.querySelector('.calin-sf-drawer');
      const mount = drawer.querySelector('[data-calin-sf-mount]');
      const currentProduct = this.dataset.currentProduct || '';
      this._app = new CalinSizeFinderApp(mount, config, currentProduct ? { currentProduct } : {});

      setTimeout(() => drawer.classList.add('open'), 50);
      setTimeout(() => {
        focusElement = event.target;
        trapFocus(drawer);
      }, 300);

      bindDrawerClose(drawer, () => this._closeDrawer(drawer));
    }

    _closeDrawer(drawer) {
      closeDrawer(drawer);
    }
  }

  class CalinPageSizeChart extends HTMLElement {
    constructor() {
      super();
      const trigger = this.querySelector('[data-calin-page-size-chart-open]');
      if (trigger) {
        trigger.addEventListener('click', (e) => this.openDrawer(e));
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const drawer = document.querySelector('.calin-size-chart-drawer.open');
          if (drawer) closeDrawer(drawer);
        }
      });
    }

    openDrawer(event) {
      event.preventDefault();
      const template = this.querySelector('[data-calin-page-size-chart-template]');
      if (!template) return;
      document.body.appendChild(template.content.cloneNode(true));
      const drawer = document.querySelector('.calin-size-chart-drawer');
      if (!drawer) return;

      setTimeout(() => drawer.classList.add('open'), 50);
      setTimeout(() => {
        focusElement = event.target;
        trapFocus(drawer);
      }, 300);

      bindDrawerClose(drawer, closeDrawer);
    }
  }

  class CalinSizeFinderInline extends HTMLElement {
    constructor() {
      super();
      this._mounted = false;
      this._app = null;
    }

    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      this._init();
    }

    async _init() {
      const config = await loadConfig(this);
      if (!config) return;
      const mount = this.querySelector('[data-calin-sf-mount]');
      if (!mount) return;
      const only = this.dataset.only || '';
      const hideReference = this.dataset.hideReference === 'true';
      const currentProduct = this.dataset.currentProduct || '';
      const options = {};
      if (only) options.only = only;
      if (hideReference) options.hideReference = true;
      if (currentProduct) options.currentProduct = currentProduct;
      this._app = new CalinSizeFinderApp(mount, config, options);
    }
  }

  if (!customElements.get('calin-size-finder')) {
    customElements.define('calin-size-finder', CalinSizeFinder);
  }

  if (!customElements.get('calin-size-finder-inline')) {
    customElements.define('calin-size-finder-inline', CalinSizeFinderInline);
  }

  if (!customElements.get('calin-page-size-chart')) {
    customElements.define('calin-page-size-chart', CalinPageSizeChart);
  }
})();
